import React, { useMemo } from "react";
import TrackerReviewsList from "./TrackerReviewsList";

/** Coach portal: scheduled reviews for trackers assigned to this coach. */
export default function TrackerReviewsListPage() {
  const coachId = useMemo(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user_data") || "{}");
      return String(user?._id || user?.user_id || "") || null;
    } catch {
      return null;
    }
  }, []);

  return <TrackerReviewsList coachIdFilter={coachId} />;
}
